{
  "greeting": "Olá! Como posso ajudá-lo com vinhos hoje?",
  "thinking": "✨ A pensar...",
  "thinkingStep": "✨ A descortiçar a combinação perfeita para si…🍷",
  "askAboutWine": "Ex. Bordeaux tinto dos anos 90 cerca de $1500 | Borgonha branco village abaixo de $600",
  "askAboutWineFirst": "Quero comprar (região + cor + colheita + orçamento)",
  "waitingForResponse": "A aguardar resposta...",
  "dailyLimitReached": "Atingiu o limite diário de consultas. Volte após as 00:00 HKT para continuar.",
  "chatHistory": "O seu histórico de chat",
  "noChatHistory": "Ainda sem histórico de chat",
  "startConversation": "Inicie uma conversa para a ver aqui",
  "backToChat": "Voltar ao chat",
  "newChat": "Novo chat",
  "history": "Histórico",
  "search": "Pesquisar",
  "whatsapp": "WhatsApp",
  "wineAdvisor": "Consultor de vinhos",
  "chat": "Chat",
  "chatNumber": "Chat {number}",
  "wineRecommended": "{count} vinho recomendado",
  "winesRecommended": "{count} vinhos recomendados",
  "justNow": "Agora mesmo",
  "minuteAgo": "Há {count} minuto",
  "minutesAgo": "Há {count} minutos",
  "hourAgo": "Há {count} hora",
  "hoursAgo": "Há {count} horas",
  "dayAgo": "Há {count} dia",
  "daysAgo": "Há {count} dias",
  "noMessagesYet": "Ainda sem mensagens",
  "perBottle": "Por garrafa",
  "priceNA": "Preço não disponível",
  "buyNow": "Comprar agora",
  "moreInformation": "Mais informações",
  "share": {
    "button": "Partilhar",
    "title": "Partilhar conversa",
    "description": "Partilhe esta conversa com os seus amigos usando o link abaixo:",
    "generating": "A gerar link de partilha...",
    "error": "Falha ao gerar link de partilha",
    "copy": "Copiar",
    "copied": "Copiado!",
    "note": "Nota: Este link expirará em 30 dias. Quando alguém abrir este link, verá uma cópia desta conversa."
  },
  "checkOutWine": "Confira este vinho: {name} {vintage}",
  "linkCopied": "Link copiado para a área de transferência!",
  "contactWhatsApp": "Contacte-nos no WhatsApp para mais opções",
  "errorLoadingWine": "Desculpe, não consegui carregar os detalhes do vinho.",
  "errorOccurred": "Ocorreu um erro ao obter a resposta.",
  "you": "Você",
  "welcome": {
    "intro": "Bem-vindo à WWX, sou a Zyra, a sua consultora de vinhos IA. Pode aceder a:",
    "features": {
      "globalMarket": "Mercado global de vinhos finos (vendedores UK, FR, HK)",
      "realTimeOffers": "Melhores ofertas em tempo real dentro do seu orçamento",
      "personalized": "Recomendações personalizadas só para si",
      "comparison": "Comparação fácil de colheitas e marcas",
      "instantCheckout": "Quantidades e envio instantâneo"
    },
    "question": "O que posso recomendar-lhe hoje?",
    "trendingPrompts": "Exemplos de consultas",
    "promptExamples": {
      "title": "Como perguntar:",
      "good": "✓ Bons exemplos:",
      "bad": "✗ Evite consultas sem orçamento:"
    },
    "prompts": {
      "bordeaux": "Bordeaux tinto cerca de $800",
      "champagne": "Champagne de produtor abaixo de $2000",
      "firstGrowth": "Melhor oferta first growth 2010-2019"
    }
  },
  "feedback": {
    "helpful": "Isto foi útil",
    "notHelpful": "Isto não foi útil",
    "thankYou": "Obrigado pelo seu feedback!",
    "whatDidYouLike": "O que gostou?",
    "whatCouldBeImproved": "O que poderia ser melhorado?",
    "category": "Categoria",
    "selectCategory": "Selecione uma categoria",
    "categories": {
      "accuracy": "Precisão",
      "helpfulness": "Utilidade",
      "responseSpeed": "Velocidade de resposta",
      "clarity": "Clareza",
      "other": "Outro"
    },
    "comments": "Comentários",
    "placeholder": "Conte-nos mais sobre a sua experiência...",
    "cancel": "Cancelar",
    "submit": "Enviar feedback",
    "submitting": "A enviar..."
  },
  "auth": {
    "limitReached": "Limite diário atingido",
    "signUpToday": "Registe-se para mais mensagens",
    "limitMessage": "Atingiu o seu limite diário de mensagens. Registe-se gratuitamente para continuar a conversar.",
    "benefitsMessage": "Crie uma conta gratuita para continuar a conversar e guardar o seu histórico de chat em todos os dispositivos.",
    "remainingMessages": "Tem {count} mensagens restantes hoje",
    "signUp": "Registar",
    "login": "Iniciar sessão",
    "loggedInAs": "Sessão iniciada como {email}",
    "logout": "Terminar sessão"
  }
}
